'use client'

import { useMemo } from 'react'
import { Text } from '@vinted/web-ui'

import { useFeatureSwitch } from '@marketplace-web/shared/feature-switches'
import { useTranslate } from '@marketplace-web/shared/i18n'

import { useCatalogContext } from 'pages/Catalog/CatalogProvider'

type Props = {
  truncate?: boolean
}

const Title = ({ truncate = false }: Props) => {
  const translate = useTranslate()
  const {
    state: { filters, data, catalogBrand, general },
  } = useCatalogContext()
  const { catalogIds, disableSearchSaving } = filters
  const { brand } = catalogBrand

  const titlesJoinElement = ' '
  const catalogTitle = general.title

  const catalogTitleFromResponseEnabled = useFeatureSwitch('web_catalog_title_from_response')

  const catalogs = useMemo(() => {
    return catalogIds
      .map(catalogId => data.catalogs.find(catalog => catalog.id === catalogId))
      .filter(Boolean)
  }, [catalogIds, data.catalogs])

  function getPopularCatalogTitle() {
    const popularCatalogTitle = translate('homepage.popular_items.catalog_title')

    if (!brand) return popularCatalogTitle

    return [popularCatalogTitle, brand.title].join(titlesJoinElement)
  }

  function getTitle() {
    const title: Array<string> = []

    if (catalogs.length === 1) {
      title.push(catalogs[0]!.title)
    }

    if (brand) {
      title.push(brand.title)
    }

    if (title.length) return title.join(titlesJoinElement)

    return translate('catalog.items')
  }

  function getText() {
    if (catalogTitleFromResponseEnabled && disableSearchSaving) {
      return catalogTitle || getTitle()
    }

    return disableSearchSaving ? getPopularCatalogTitle() : getTitle()
  }

  return <Text type={Text.Type.Heading} text={getText()} truncate={truncate} as="h1" />
}

export default Title
